@if (filterable()) {
<div class="flex items-center pb-3">
  <div class="relative w-full max-w-xs">
    <svg lucideSearch class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400"></svg>
    <input hlmInput [value]="globalFilter()" (input)="setFilter($any($event.target).value)"
      [placeholder]="filterPlaceholder()"
      class="h-9 w-full pl-9 border-slate-200 focus-visible:border-sakoo-green focus-visible:ring-sakoo-green/20" />
  </div>
</div>
}

<div hlmTableContainer class="rounded-lg border border-slate-100" [style.min-height]="minHeight()">
  <table hlmTable>
    <thead hlmTHead class="bg-slate-50">
      <tr hlmTr>
        @for (col of columns(); track col.key) {
        <th hlmTh [class]="headClasses(col)"
          class="text-slate-700 text-xs font-semibold uppercase tracking-wider">
          @if (col.sortable) {
          <button type="button" (click)="toggleSort(col.key)"
            class="inline-flex items-center gap-1 hover:text-slate-900 transition-colors">
            <span>{{ col.header }}</span>
            @switch (sortDirection(col.key)) {
            @case ('asc') {
            <svg lucideArrowUp class="h-3.5 w-3.5"></svg>
            }
            @case ('desc') {
            <svg lucideArrowDown class="h-3.5 w-3.5"></svg>
            }
            @default {
            <svg lucideChevronsUpDown class="h-3.5 w-3.5 opacity-40"></svg>
            }
            }
          </button>
          } @else {
          {{ col.header }}
          }
        </th>
        }
      </tr>
    </thead>
    <tbody hlmTBody>
      @if (loading()) {
      <tr hlmTr>
        <td hlmTd [attr.colspan]="columns().length" class="py-10">
          <div class="flex items-center justify-center gap-2 text-slate-400">
            <hlm-spinner class="text-xl" />
            <span class="text-sm font-medium">{{ loadingMessage() }}</span>
          </div>
        </td>
      </tr>
      } @else {
      @for (row of table.getRowModel().rows; track row.id) {
      <tr hlmTr [attr.data-state]="isSelected(row.original) ? 'selected' : null"
        [class.cursor-pointer]="rowClickable()" [class.group]="true" (click)="onRowClick(row.original)">
        @for (col of columns(); track col.key) {
        <td hlmTd [class]="cellClasses(col)" class="text-slate-600">
          @if (col.cell) {
          <ng-container *ngTemplateOutlet="col.cell; context: cellContext(col, row.original)" />
          } @else {
          {{ displayValue(col, row.original) }}
          }
        </td>
        }
      </tr>
      } @empty {
      <tr hlmTr>
        <td hlmTd [attr.colspan]="columns().length" class="text-center py-8 text-slate-400">
          {{ emptyMessage() }}
        </td>
      </tr>
      }
      }
    </tbody>
  </table>
</div>

@if (showPagination()) {
<hlm-numbered-pagination class="pt-2" [currentPage]="currentPage()"
  (currentPageChange)="onCurrentPageChange($event)" [itemsPerPage]="pageSizeState()"
  (itemsPerPageChange)="onItemsPerPageChange($event)" [totalItems]="filteredCount()"
  [pageSizes]="pageSizes()" [showPageSizes]="showPageSizeSelector()" />
}
